import {
  Alert,
  Button,
  CircularProgress,
  Grid,
  Snackbar,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useState, useEffect } from "react";

import logo from "../../Assets/afrodita-logo.jpg";

const APIBASE = "https://afrodita-kozmetika.hu/api/szeminarium.php";

function Login({ logIn }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState({ error: false, text: "" });
  const [loading, setLoading] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);

  const [images, setImages] = useState([]);

  useEffect(() => {
    axios
      .get("https://afrodita-kozmetika.hu/api/sliders.php")
      .then((response) => {
        setImages(response.data);
      });
  }, []);

  const handleClick = async () => {
    if (email.length > 0) {
      setLoading(true);

      const response = await axios.get(APIBASE + "?login=" + email);

      if (response.data.id == null) {
        setLoading(false);
        setError({ error: true, text: "A megadott email cím nem található" });
      } else {
        setLoading(false);
        logIn(response.data);
      }
    } else {
      setError({ error: true, text: "Email cím megadása kötelező!" });
    }
  };

  return (
    <div>
      <div className={"login"}>
        <Grid container>
          <Grid
            display={{ xs: "none", lg: "block" }}
            style={{
              background: "#ecf0f1",
              borderTopLeftRadius: "10px",
              borderBottomLeftRadius: "10px",
            }}
            item
            xs={0}
            md={7}
          >
            {images.length !== 0 && (
              <div style={{ paddingTop: "50px" }}>
                <div>
                  <img
                    alt={"Banner"}
                    src={images[currentImage].image}
                    style={{ height: "200px" }}
                  />
                </div>
                <div className={"textTitle"}>{images[currentImage].title}</div>
                <div className={"text"}>{images[currentImage].text}</div>
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    paddingBottom: "5px",
                  }}
                >
                  {images.map((image, idx) => {
                    return currentImage === idx ? (
                      <div
                        className={"switcher active"}
                        onClick={() => setCurrentImage(idx)}
                      />
                    ) : (
                      <div
                        className={"switcher"}
                        fontSize={"small"}
                        onClick={() => setCurrentImage(idx)}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </Grid>

          <Grid
            style={{
              padding: "80px 20px",
              background: "#fff",
              borderTopRightRadius: "10px",
              borderBottomRightRadius: "10px",
            }}
            item
            xs={12}
            md={5}
          >
            <img
              src={logo}
              alt={"Afrodita Kozmetika logo"}
              className={"logo"}
            />

            <div className={"title"}>
              Afrodita Kozmetika
              <br />
              <span>Szemináriumi termék és arlista</span>
            </div>

            <div>
              <div className={"formLabel"}>
                Email cím amivel a szeminariumra regisztráltál:
              </div>
              <TextField
                fullWidth
                error={error.error}
                style={{ marginBottom: "20px" }}
                id="outlined-basic"
                variant="outlined"
                size="small"
                margin="normal"
                onChange={(event) => setEmail(event.target.value)}
              />
            </div>
            <Button fullWidth variant="contained" onClick={() => handleClick()}>
              {!loading ? (
                "Bejelentkezés"
              ) : (
                <CircularProgress color="inherit" size={22} />
              )}
            </Button>
          </Grid>
        </Grid>
      </div>

      <Snackbar
        open={error.error}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity="error">{error.text}</Alert>
      </Snackbar>
    </div>
  );
}

export default Login;
